//ThreePicto.vue



/* eslint-disable no-undef */
<template>

	<div id="wrapper">

		<div id="container" @mousedown="onMouseDown" @mouseup="onMouseUp">
		</div>

	</div>

	<!-- <button id="tell-me" @click="onClickTestMe">
		Test
	</button> -->

</template>

<script>

//----------------------------------------------------------------
//								IMPORT 
//----------------------------------------------------------------

//Import Three.js
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass";
import {FontLoader} from "three/examples/jsm/loaders/FontLoader.js";

import {TextGeometry} from "three/examples/jsm/geometries/TextGeometry.js";


//Import project classes


//Import Vue.js components


THREE.Object3D.DefaultUp.set(0, 0, 1);

window.THREE = THREE;



//----------------------------------------------------------------
//								VARIABLES 
//----------------------------------------------------------------

//For Three.js
let container, renderer, scene, camera, orbitControl, transformControl, composer;
scene = new THREE.Scene();
// let sceneContent;


export default {
	components: {
		
  },
  data() {
	return {
		
	};
  },
  methods: {  
	init() {
		container = document.getElementById("container");

		// Camera
		camera = new THREE.PerspectiveCamera(60, container.clientWidth / container.clientHeight, 0.01, 10000000);
		camera.position.set(0, -14, 6);
		camera.lookAt(new THREE.Vector3());
		scene = new THREE.Scene();

		//Renderer
		renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
		renderer.xr.enabled = true;
		renderer.setSize(container.clientWidth, container.clientHeight);
		renderer.setPixelRatio(window.devicePixelRatio);
		// renderer.setClearColor(0xf2f2f2);
		renderer.setClearColor(0xd4d4d4, 0);
		container.appendChild(renderer.domElement);

		//Composer
		composer = new EffectComposer(renderer);
		composer.addPass(new RenderPass(scene, camera));

		//Lights
		const light = new THREE.SpotLight( 0xffffff, 1.5 );
		light.position.set( 0, 1500, 200 );
		light.angle = Math.PI * 0.2;
		light.castShadow = true;
		light.shadow.camera.near = 200;
		light.shadow.camera.far = 2000;
		light.shadow.bias = - 0.000222;
		light.shadow.mapSize.width = 1024;
		light.shadow.mapSize.height = 1024;
		scene.add( light );


		//Controls
		orbitControl = new OrbitControls(camera, renderer.domElement);
		orbitControl.enableDamping = true;
		orbitControl.dampingFactor = 0.2;
		orbitControl.update();

		//Grid and Axes
		// const mainGrid = new THREE.GridHelper( 100, 100 );
		// mainGrid.geometry.rotateX( Math.PI / 2 );
		// mainGrid.material.opacity = 0.25;
		// mainGrid.material.transparent = true;

		// const grid10m = new THREE.GridHelper( 100, 10 );
		// grid10m.geometry.rotateX( Math.PI / 2 );
		// grid10m.material.opacity = 0.45;
		// grid10m.material.transparent = true;
		
		// scene.add( mainGrid,  grid10m);

		// const axesHelper = new THREE.AxesHelper( 3 );    //x-Axis -> red, y-Axis -> green, z-Axis -> blue
		// scene.add( axesHelper );



		//Texture
		const textureLoader = new THREE.TextureLoader()

		//Lights 
		const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
		scene.add(ambientLight);

		const pointLight = new THREE.PointLight(0xffffff, 0.5);
		pointLight.position.x = 2;
		pointLight.position.x = 3;
		pointLight.position.x = 4;

		scene.add(pointLight);

		//Material
		const textMaterial = new THREE.MeshLambertMaterial(
		);
		// textMaterial.flatShading = true
		textMaterial.wireframe = false;
		textMaterial.color = new THREE.Color('#3b3a39');
		textMaterial.emissive = new THREE.Color('#000000');





		// Fonts
		const loader = new FontLoader();

		loader.load( 'fonts/helvetiker_regular.typeface.json', function ( font ) {

			const bGeom = new TextGeometry( 'B', {
				font: font,
				size: 2,
				height: 0.5,
				curveSegments: 6,
				bevelEnabled: true,
				bevelThickness: 0.03,
				bevelSize: 0.02,
				bevelOffset: 0,
				bevelSegments: 5
			} );
			const plusGeom = new TextGeometry( '+', {
				font: font,
				size: 2,
				height: 0.5,
				curveSegments: 6,
				bevelEnabled: true,
				bevelThickness: 0.03,
				bevelSize: 0.02,
				bevelOffset: 0,
				bevelSegments: 5
			} );
			const gGeom = new TextGeometry( 'G', {
				font: font,
				size: 2,
				height: 0.5,
				curveSegments: 6,
				bevelEnabled: true,
				bevelThickness: 0.03,
				bevelSize: 0.02,
				bevelOffset: 0,
				bevelSegments: 5
			} );

			const bMesh = new THREE.Mesh(bGeom, textMaterial);
			const plusMesh = new THREE.Mesh(plusGeom, textMaterial);
			const gMesh = new THREE.Mesh(gGeom, textMaterial);

			bMesh.rotateX(Math.PI/2); 
			plusMesh.rotateX(Math.PI/2); 
			gMesh.rotateX(Math.PI/2); 

			bMesh.translateX(-2.1);
			plusMesh.translateX(-0.8);
			gMesh.translateX(.5);

			bMesh.translateY(3.2);
			plusMesh.translateY(1.6);
			gMesh.translateY(0);

			bMesh.translateZ(-0.25);
			plusMesh.translateZ(-0.25);
			gMesh.translateZ(-0.25);

			const group = new THREE.Group();
			group.add( bMesh );
			group.add( plusMesh );
			group.add( gMesh );

			scene.add(group);

			const clock = new THREE.Clock(); 

			//Animation 
			// const tick = () => 
			// {
			// 	const elapsedTime = clock.getElapsedTime();
			// 	group.rotation.z  = elapsedTime * 0.2;
			// 	renderer.render(scene, camera); 
			// 	window.requestAnimationFrame(tick)
			// }

			// tick();

		} );


		//Event listeners
		window.addEventListener( 'pointermove', this.onPointerMove );
		window.addEventListener( 'pointerdown', this.onPointerDown );
		window.addEventListener( 'pointerup', this.onPointerUp );

	},

	onClickTestMe() {
		console.log('test me clicked');		
	},
	// onMouseDown() {
	// },
	// onMouseUp() {
	// } 
	onContainerResize() {
		camera.aspect = container.clientWidth / container.clientHeight;
		camera.updateProjectionMatrix();
		renderer.setSize(container.clientWidth, container.clientHeight);
	},
	animate() {
		renderer.setAnimationLoop(() => {
			// controls.update();
			composer.render();
			renderer.render(scene, camera);
		});
	},
	render() {
		renderer.render(scene, camera);
	},
  },
  mounted() {
	this.init();
	this.animate();
	setTimeout(this.loadModel, 2000);
  }
};
</script>



<style scoped>

#container {
  width: 100%;
  height: 100%;
  padding: 0px;
  margin: 0px;
  overflow: hidden;
  position: absolute;

}

#wrapper {
  /* background: black; */
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  overflow: hidden;
  /* position: absolute; */
}

#container-button-draw {
  padding: 5px;
  height: 50px;
  width: 350px;
  top: 90%;
  left: 50%;
  /* border: 2px solid rgba(30, 30, 30, 0.2); */
  position: fixed;
  background: #d4d4d4;
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3); 
  align-items: center;
  display: flex;
  justify-content: space-between;
  transform: translate(-50%, 0);
  /* border: 1px solid #fff; */
}

.checkbox-draw {
	/* -webkit-appearance: none; */
	cursor: pointer;
	transition: all 0.05s linear;
	/* border: 1px solid #fff; */
	/* display: table-cell; */
    /* display:flex; */
}

.checkbox-draw-label {
	max-height: 14px;
	/* min-height: 3px; */
	width: 120px;
	/* border: 1px solid #fff; */
	/* border-radius: 5px; */
	/* cursor: pointer; */
	color:rgba(110, 110, 110, 0.6);
	/* text-align: center; */
	background-color: transparent;
	/* box-shadow: 0px 2px 6px -2px rgba(0, 0, 0, 0.3); */
	font-family: Roboto;
    font-weight: 600;
    font-size: 14px;
	text-transform: uppercase;
    letter-spacing: 1px;
	line-height: 1;
}

input[name=checkDrawBuilding] {
	transform: translateY(-7px);
    /* position: relative; */
    visibility: hidden;
    cursor: pointer;
}

input[name=checkDrawBuilding]:after {
    display: block;
    content: "DRAW";
    /* position: absolute; */
	border: 1px solid rgba(110, 110, 110, 1);
    top: 0;
    /* right: -30px; */
    visibility: visible;
    height: 24px;
    line-height: 24px;
    width: 50px;
    text-align: center;
    border-radius: 4px;
    background: transparent;
    color:rgba(110, 110, 110, 1);
    font-weight: 600;
    cursor: pointer;
}

input[name=checkDrawBuilding]:checked:after {
    content: "SAVE";
    background: rgb(255, 255, 255, .8);
}

input[name=checkDrawCore] {
	transform: translateY(-7px);
    /* position: relative; */
    visibility: hidden;
    cursor: pointer;
}

input[name=checkDrawCore]:after {
    display: block;
    content: "DRAW";
    /* position: absolute; */
	border: 1px solid rgba(110, 110, 110, 1);
    top: 0;
    /* right: -30px; */
    visibility: visible;
    height: 24px;
    line-height: 24px;
    width: 50px;
    text-align: center;
    border-radius: 4px;
    background: transparent;
    color:rgba(110, 110, 110, 1);
    font-weight: 600;
    cursor: pointer;
}

input[name=checkDrawCore]:checked:after {
    content: "SAVE";
    background: rgb(255, 255, 255, .8);
}

input[name=checkDrawCore]:hover {
	border: 5px solid rgba(110, 110, 110, 1);
}


#container-command-line {
  padding: 5px;
  height: 30px;
  width: 400px;
  top: 10%;
  left: 50%;
  border: 2px solid rgba(30, 30, 30, 0.2);
  position: fixed;
  background: #d4d4d4;
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  color: rgba(0, 0, 0, 0.3);
  align-items: center;
  display: flex;
  justify-content: space-evenly;
  transform: translate(-50%, 0);
}


#inputBar {
	position: fixed;
	vertical-align: middle;
	top: 10%;
	left: 10px;
}

#resultBar {
	position: fixed;
	vertical-align: middle;
	top: 10%;
	right: 10px;
}


#value-test {
	position: fixed;
	vertical-align: middle;
	top: 10%;
	left: 90%;
}


.draw-title{
	opacity: 0;
	color: black;
	font-family: Roboto;
	font-weight: 300;
	font-size: 14px;
	text-align: center;
	display: flex;
    justify-content: space-between; 
    align-items: center;
}

#container-draw {
	padding: 10px;
	height: 80px;
	max-width: 200px;
	top: 85%;
	left: 50%;
	/* border: 2px solid rgba(30, 30, 30, 0.2); */
	position: fixed;
	background: transparent;
	border-radius: 10px;
	display: block;
	justify-content: space-between;
	transform: translate(-50%, 0);
}


.container-button-draw {
	margin-top: 10px;
	align-items: center;
	display: flex;
}

.button-draw {
	padding: 5px;
	margin-right: 15px;
	border-radius: 50%;
	border: 2px solid rgba(107, 107, 107, 1);
	height: 50px;
	width: 50px;
	background: #f0f0f0;
	cursor: pointer;
}

.button-draw:last-child {
	margin-right: 0;
}

.button-draw:hover {
	/* background: rgb(219, 219, 219); */
	border: 1px solid rgba(66, 66, 66, 1);
}

.button-draw:active {
	opacity: .8;
}

.icon {
	height: 24px;
}

.button-edit {
	padding: 5px;
	/* margin-right: 10px; */
	border-radius: 5px;
	border: 1px solid rgba(0, 0, 0, 1);
	height: 30px;
	width: 35px;
	background: white;;
}

#tell-me {
	top: 85%;
	left: 5%;
	position: fixed;
}



</style>